import React, { useState, useEffect } from "react";
import {
  Card,
  CardBody,
  Col,
  Container,
  Row,
  Input,
  Table,
  Button,
  Badge,
  Spinner,
  Alert,
} from "reactstrap";
import http from "../../services/http";

const ScenesList = () => {
  const [scenes, setScenes] = useState([]);
  const [filteredScenes, setFilteredScenes] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [searchTerm, setSearchTerm] = useState("");

  const API_BASE = process.env.REACT_APP_VIDEO_API;

  useEffect(() => {
    fetchScenes();
  }, []);

  useEffect(() => {
    const filtered = scenes.filter(
      (scene) =>
        scene.prompt?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        scene.sceneId?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        scene.scene_number?.toString().includes(searchTerm)
    );
    setFilteredScenes(filtered);
  }, [searchTerm, scenes]);

  const fetchScenes = async () => {
    try {
      const response = await http.get(`${API_BASE}/scenes`);
      console.log('Scenes API Response:', response.data);
      setScenes(response.data.scenes || []);
      setLoading(false);
    } catch (err) {
      console.error('Scenes fetch error:', err);
      setError("Failed to fetch scenes");
      setLoading(false);
    }
  };

  const handleDownload = (sceneUrl, sceneId) => {
    const link = document.createElement("a");
    link.href = sceneUrl;
    link.download = `scene-${sceneId}.jpg`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const handleView = (sceneUrl) => {
    window.open(sceneUrl, "_blank");
  };

  const formatDate = (dateString) => {
    return new Date(dateString).toLocaleDateString("en-US", {
      year: "numeric",
      month: "short",
      day: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    });
  };

  if (loading) {
    return (
      <div className="page-body">
        <Container fluid>
          <div className="text-center mt-5">
            <Spinner color="primary" />
            <p className="mt-2">Loading scenes...</p>
          </div>
        </Container>
      </div>
    );
  }

  return (
    <div className="page-body">
      <Container fluid>
        <Row>
          <Col sm={12}>
            <Card>
              <div className="card-header d-flex justify-content-between align-items-center">
                <h5 className="mb-0">Generated Scenes</h5>
                <Button
                  color="primary"
                  href={`${process.env.PUBLIC_URL}/stories`}
                >
                  Generate Story
                </Button>
              </div>
              <CardBody>
                {error && (
                  <Alert color="danger" className="mb-3">
                    {error}
                  </Alert>
                )}

                <Row className="mb-3">
                  <Col md={6}>
                    <Input
                      type="text"
                      placeholder="Search by prompt, scene ID, or scene number..."
                      value={searchTerm}
                      onChange={(e) => setSearchTerm(e.target.value)}
                    />
                  </Col>
                  <Col md={6} className="text-end">
                    <Badge color="info">
                      {filteredScenes.length} scene
                      {filteredScenes.length !== 1 ? "s" : ""} found
                    </Badge>
                  </Col>
                </Row>

                <Table responsive striped hover>
                  <thead>
                    <tr>
                      <th>#</th>
                      <th>Preview</th>
                      <th>Prompt</th>
                      <th>Scene Number</th>
                      <th>Scene ID</th>
                      <th>Status</th>
                      <th>Created</th>
                      <th>Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {filteredScenes.length === 0 ? (
                      <tr>
                        <td colSpan="8" className="text-center py-4">
                          {searchTerm
                            ? "No scenes found matching your search."
                            : "No scenes generated yet."}
                        </td>
                      </tr>
                    ) : (
                      filteredScenes.map((scene, index) => (
                        <tr key={scene.sceneId}>
                          <td>{index + 1}</td>
                          <td>
                            <img
                              src={scene.image_url}
                              alt="Preview"
                              width="80"
                              height="60"
                              style={{
                                objectFit: "cover",
                                borderRadius: "4px",
                              }}
                            />
                          </td>
                          <td>
                            <div style={{ maxWidth: "200px" }}>
                              <small>{scene.prompt}</small>
                            </div>
                          </td>
                          <td>
                            <Badge color="info">Scene {scene.scene_number}</Badge>
                          </td>
                          <td>
                            <small>{scene.sceneId}</small>
                          </td>
                          <td>
                            <Badge
                              color={
                                scene.status === "ready"
                                  ? "success"
                                  : "warning"
                              }
                              className="text-capitalize"
                            >
                              {scene.status}
                            </Badge>
                          </td>
                          <td>
                            <small>{formatDate(scene.createdAt)}</small>
                          </td>
                          <td>
                            <div className="d-flex gap-1">
                              <Button
                                color="primary"
                                size="sm"
                                onClick={() => handleView(scene.image_url)}
                                title="View Scene"
                              >
                                <i className="fa fa-eye"></i>
                              </Button>
                              <Button
                                color="success"
                                size="sm"
                                onClick={() =>
                                  handleDownload(scene.image_url, scene.sceneId)
                                }
                                title="Download Scene"
                              >
                                <i className="fa fa-download"></i>
                              </Button>
                            </div>
                          </td>
                        </tr>
                      ))
                    )}
                  </tbody>
                </Table>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default ScenesList;